import ReactDOM from 'react-dom';
import GithubApp from './GithubApp';
import './index.css';


ReactDOM.render(<GithubApp />, document.getElementById('root'));
